export const teamAvailability = {
  members: [
    {
      id: 'u1',
      name: 'Alice Johnson',
      role: 'Frontend Engineer',
      unavailable: [
        { start: '2025-11-03', end: '2025-11-05', task: 'Website Redesign' },
        { start: '2025-11-12', end: '2025-11-12', task: 'PTO' }
      ]
    },
    {
      id: 'u2',
      name: 'Ravi Kumar',
      role: 'Backend Engineer',
      unavailable: [
        { start: '2025-11-07', end: '2025-11-08', task: 'DB Migration' },
        { start: '2025-11-18', end: '2025-11-20', task: 'API Release' }
      ]
    },
    {
      id: 'u3',
      name: 'Chen Wei',
      role: 'QA Engineer',
      unavailable: [
        { start: '2025-11-01', end: '2025-11-02', task: 'Conference' },
        { start: '2025-11-15', end: '2025-11-15', task: 'Medical' }
      ]
    }
  ]
};

export function getDateRange(startISO, endISO) {
  const start = new Date(startISO);
  const end = new Date(endISO);
  const days = [];
  if (isNaN(start.getTime()) || isNaN(end.getTime()) || start > end) return days;
  const d = new Date(start);
  while (d <= end) {
    const iso = d.toISOString().slice(0, 10);
    const dow = d.getDay();
    days.push({ iso, date: new Date(d), isWeekend: dow === 0 || dow === 6 });
    d.setDate(d.getDate() + 1);
  }
  return days;
}

export function isDateWithinRange(dateISO, range) {
  return dateISO >= range.start && dateISO <= range.end;
}

export function getMonthMatrix(year, monthIndex /* 0-11 */) {
  const firstOfMonth = new Date(Date.UTC(year, monthIndex, 1));
  const startDay = firstOfMonth.getUTCDay();
  const daysInMonth = new Date(Date.UTC(year, monthIndex + 1, 0)).getUTCDate();
  // Calendar starts on Sunday: go back startDay days
  const startDate = new Date(Date.UTC(year, monthIndex, 1 - startDay));
  const cells = [];
  for (let i = 0; i < 42; i++) { // 6 weeks * 7 days
    const d = new Date(startDate);
    d.setUTCDate(startDate.getUTCDate() + i);
    const iso = d.toISOString().slice(0, 10);
    const dow = d.getUTCDay();
    const inCurrentMonth = d.getUTCMonth() === monthIndex;
    cells.push({ iso, date: new Date(d), isWeekend: dow === 0 || dow === 6, inCurrentMonth });
  }
  return cells;
}


